import {
  parsePhoneNumberFromString,
  findPhoneNumbersInText,
  isValidNumber
} from 'libphonenumber-js'

export const formatPhoneToNational = (phone) => {
  if (typeof phone !== 'string' || !phone) {
    return phone
  }
  const phoneNumber = parsePhoneNumberFromString(phone, 'US')
  return phoneNumber ? phoneNumber.formatNational() : phone
}

export function convertPhoneToE164(phone) {
  if (typeof phone !== 'string' || !phone || (phone && phone.trim() === '')) {
    return phone
  }
  const cleaned = phone.replace(/\D/g, '') // Removes non-digit characters
  return `+1${cleaned}`
}

export const validatePhoneNumber = (phone) => /^\(\d{3}\) \d{3}-\d{4}$/.test(phone)

export const formatPhoneToNationalWithCountry = (phone, country) => {
  if (typeof phone !== 'string' || !phone) {
    return phone
  }

  // current temporary workaround while formatting is determined
  if (country === 'KR') {
    return phone
  }

  const phoneNumber = parsePhoneNumberFromString(phone, country)
  return phoneNumber ? phoneNumber.formatNational() : phone
}

export const findCountryInNumber = (phone) => {
  if (typeof phone !== 'string' || !phone) {
    return phone
  }

  return findPhoneNumbersInText(phone)
}

export function convertPhoneToE164WithCountryCode(phone, country) {
  if (typeof phone !== 'string' || !phone || (phone && phone.trim() === '')) {
    return phone
  }
  let cleaned = phone.replace(/\D/g, '') // Removes non-digit characters

  // Checks if number is from Japan, Korea or India, which adds a leading 0
  // Checks length in edge case where leading zero not sent on submit
  if ((country === '+81' || country === '+82' || country === '+91') && cleaned.length >= 10 && cleaned[0] === '0') {
    cleaned = cleaned.slice(1)
  }
  return `${country}${cleaned}`
}

export const CheckPhoneNumber = (phone, country) => {
  const isValid = isValidNumber(phone, country)

  return isValid
}
